import { render, staticRenderFns } from "./SelectTextPanel.vue?vue&type=template&id=66bd9d4d&scoped=true&"
import script from "./SelectTextPanel.vue?vue&type=script&lang=js&"
export * from "./SelectTextPanel.vue?vue&type=script&lang=js&"
import style0 from "./SelectTextPanel.vue?vue&type=style&index=0&id=66bd9d4d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bd9d4d",
  null
  
)

export default component.exports